import { render, staticRenderFns } from "./AgreementPrivacy.vue?vue&type=template&id=65f1cea9&scoped=true&"
import script from "./AgreementPrivacy.vue?vue&type=script&lang=js&"
export * from "./AgreementPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPrivacy.vue?vue&type=style&index=0&id=65f1cea9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1cea9",
  null
  
)

export default component.exports